import "animate.css";
import { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import TrackVisibility from "react-on-screen";
// import contactInfoAnimation from "../assets/Animation/avatar.json";
import contactImg from "../assets/img/contact-img.svg";

export const Contact = () => {
  // const formInitialDetails = {
  //   firstName: "",
  //   lastName: "",
  //   email: "",
  //   phone: "",
  //   message: "",
  // };
  // const [formDetails, setFormDetails] = useState(formInitialDetails);
  const [buttonText, setButtonText] = useState("Send");

  return (
    <section className="contact" id="connect">
      <Container>
        <Row className="align-items-center">
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <img
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                  src={contactImg}
                  alt="Contact Us"
                />
              )}
            </TrackVisibility>
          </Col>
          <Col size={12} md={6}>
            <TrackVisibility>
              {({ isVisible }) => (
                <div
                  className={
                    isVisible ? "animate__animated animate__fadeIn" : ""
                  }
                >
                  <h2>Get In Touch</h2>
                  <form
                    action="https://formsubmit.co/kamrulhasanofficialmail@gmail.com"
                    method="POST"
                  >
                    <input
                      type="text"
                      name="name"
                      required
                      placeholder="Your Name..."
                    />
                    <input
                      type="email"
                      name="email"
                      required
                      placeholder="Your Email..."
                    />

                    <input type="hidden" name="_captcha" value="false"></input>
                    <textarea
                      type="text"
                      name="message"
                      required
                      placeholder="Message..."
                    />
                    <button type="submit">
                      <span>{buttonText}</span>
                    </button>
                  </form>
                </div>
              )}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
